export const getCurrentDate = () => {
  let date = new Date();
  let day = date.getDate();
  let month = date.getMonth().toString();
  let year = date.getFullYear().toString();
  let hour = date.getHours();
  let minute = date.getMinutes();
  let second = date.getSeconds();

  if (day < 10) {
    day = `0${day.toString()}`;
  } else {
    day = day.toString();
  }

  if (hour < 10) {
    hour = `0${hour.toString()}`;
  } else {
    hour = hour.toString();
  }

  if (minute < 10) {
    minute = `0${minute.toString()}`;
  } else {
    minute = minute.toString();
  }

  if (second < 10) {
    second = `0${second.toString()}`;
  } else {
    second = second.toString();
  }

  let months = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];

  return `${year}-${months[month]}-${day}T${hour}:${minute}:${second}.000Z`;
};

export const getCurrentDatePlus = (stringDate, plus) => {
  let date = new Date(stringDate);
  date.setDate(date.getDate() + plus);
  let newDate = date.toISOString();
  return newDate;
};

export default getCurrentDate;
